module.exports = __webpack_public_path__ + "static/media/Ruben_Arcas_Navarro.8dd56070.jpg";